import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyChgHEl_lT7ARqCW5qyt0mZzOVoBnHatmA',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'gen-ai-poc-onboarding.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'gen-ai-poc-onboarding',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'gen-ai-poc-onboarding.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '113875395623',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:113875395623:web:3301c2e7d9733506ce1a02',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
